import { startOfDay, endOfDay, subDays, subYears } from 'date-fns'
import { ACCEPT_JSON_HEADERS, INTERNAL_API_ROOT } from '../../config/api'
import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { pagedResponse } from '../../utils/pagedResponse'
import { infoNotification, errorNotification } from '../application/notifications'

// TYPES & ACTIONS
export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'

export const getUser = userId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}`,
      types: [GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE],
    },
  })
}

export const SET_USER_DETAIL_REQUEST = 'SET_USER_DETAIL_REQUEST'
export const SET_USER_DETAIL_SUCCESS = 'SET_USER_DETAIL_SUCCESS'
export const SET_USER_DETAIL_FAILURE = 'SET_USER_DETAIL_FAILURE'
export const RESET_SET_USER_DETAIL_ERROR = 'RESET_SET_USER_DETAIL_ERROR'
export const setUserDetail = (userId, payload) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PUT',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}`,
      body: JSON.stringify(payload),
      types: [SET_USER_DETAIL_REQUEST, SET_USER_DETAIL_SUCCESS, SET_USER_DETAIL_FAILURE],
    },
  })
}

export const GET_USER_SUBMISSIONS_REQUEST = 'GET_USER_SUBMISSIONS_REQUEST'
export const GET_USER_SUBMISSIONS_SUCCESS = 'GET_USER_SUBMISSIONS_SUCCESS'
export const GET_USER_SUBMISSIONS_FAILURE = 'GET_USER_SUBMISSIONS_FAILURE'

export const getUserSubmissions =
  (userId, page = 1, pageSize = 20) =>
  dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/submissions/user/${userId}?IncludeArchivedSubmissions=true&page=${page}&pageSize=${pageSize}`,
        types: [
          GET_USER_SUBMISSIONS_REQUEST,
          GET_USER_SUBMISSIONS_SUCCESS,
          GET_USER_SUBMISSIONS_FAILURE,
        ],
      },
    })
  }

export const GET_USER_ORGANIZATIONS_REQUEST = 'GET_USER_ORGANIZATIONS_REQUEST'
export const GET_USER_ORGANIZATIONS_SUCCESS = 'GET_USER_ORGANIZATIONS_SUCCESS'
export const GET_USER_ORGANIZATIONS_FAILURE = 'GET_USER_ORGANIZATIONS_FAILURE'

export const getUserOrganizations = userId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/organizations`,
      types: [
        GET_USER_ORGANIZATIONS_REQUEST,
        GET_USER_ORGANIZATIONS_SUCCESS,
        GET_USER_ORGANIZATIONS_FAILURE,
      ],
    },
  })
}

export const GET_USER_PUBLISHERS_REQUEST = 'GET_USER_PUBLISHERS_REQUEST'
export const GET_USER_PUBLISHERS_SUCCESS = 'GET_USER_PUBLISHERS_SUCCESS'
export const GET_USER_PUBLISHERS_FAILURE = 'GET_USER_PUBLISHERS_FAILURE'

export const getUserPublishers =
  (userId, page = 1) =>
  dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/publishers?page=${page}`,
        types: [
          GET_USER_PUBLISHERS_REQUEST,
          GET_USER_PUBLISHERS_SUCCESS,
          GET_USER_PUBLISHERS_FAILURE,
        ],
      },
    })
  }

export const GET_USER_PAYMENTS_REQUEST = 'GET_USER_PAYMENTS_REQUEST'
export const GET_USER_PAYMENTS_SUCCESS = 'GET_USER_PAYMENTS_SUCCESS'
export const GET_USER_PAYMENTS_FAILURE = 'GET_USER_PAYMENTS_FAILURE'

export const getUserPayments =
  ({ userId, dateRange, page = 1, limit = 20, applyDefaultYearStartDate = false }) =>
  dispatch => {
    let cleanedRange = dateRange
    if (dateRange == null) {
      cleanedRange = [null, null]
    }
    if (cleanedRange[0] == null) {
      cleanedRange[0] = applyDefaultYearStartDate
        ? subYears(new Date(), 100)
        : subDays(new Date(), 90)
    }
    if (cleanedRange[1] == null) {
      cleanedRange[1] = new Date()
    }

    const startDate = startOfDay(cleanedRange[0]).toJSON()
    const endDate = endOfDay(cleanedRange[1]).toJSON()

    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/payments?pageSize=${limit}&page=${page}&start=${startDate}&end=${endDate}`,
        types: [GET_USER_PAYMENTS_REQUEST, GET_USER_PAYMENTS_SUCCESS, GET_USER_PAYMENTS_FAILURE],
      },
    })
  }

export const GET_USER_ACCESS_STATUS_REQUEST = 'GET_USER_ACCESS_STATUS_REQUEST'
export const GET_USER_ACCESS_STATUS_SUCCESS = 'GET_USER_ACCESS_STATUS_SUCCESS'
export const GET_USER_ACCESS_STATUS_FAILURE = 'GET_USER_ACCESS_STATUS_FAILURE'

export const getUserAccessStatus = userId => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/status`,
      types: [
        GET_USER_ACCESS_STATUS_REQUEST,
        GET_USER_ACCESS_STATUS_SUCCESS,
        GET_USER_ACCESS_STATUS_FAILURE,
      ],
    },
  })
}

export const SET_USER_ACCESS_STATUS_REQUEST = 'SET_USER_ACCESS_STATUS_REQUEST'
export const SET_USER_ACCESS_STATUS_SUCCESS = 'SET_USER_ACCESS_STATUS_SUCCESS'
export const SET_USER_ACCESS_STATUS_FAILURE = 'SET_USER_ACCESS_STATUS_FAILURE'

export const setUserAccess = (userId, status) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PUT',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/status`,
      types: [
        SET_USER_ACCESS_STATUS_REQUEST,
        SET_USER_ACCESS_STATUS_SUCCESS,
        SET_USER_ACCESS_STATUS_FAILURE,
      ],
      body: JSON.stringify({ userId, isActive: status }),
    },
  })
}

export const GET_FORM_VISITS_REQUEST = 'GET_FORM_VISITS_REQUEST'
export const GET_FORM_VISITS_SUCCESS = 'GET_FORM_VISITS_SUCCESS'
export const GET_FORM_VISITS_FAILURE = 'GET_FORM_VISITS_FAILURE'

export const getFormVisits =
  (userId, page = 1) =>
  dispatch => {
    return dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/draftSubmissions?page=${page}`,
        types: [GET_FORM_VISITS_REQUEST, GET_FORM_VISITS_SUCCESS, GET_FORM_VISITS_FAILURE],
      },
    })
  }

export const DELETE_FORM_VISITS_REQUEST = 'DELETE_FORM_VISITS_REQUEST'
export const DELETE_FORM_VISITS_SUCCESS = 'DELETE_FORM_VISITS_SUCCESS'
export const DELETE_FORM_VISITS_FAILURE = 'DELETE_FORM_VISITS_FAILURE'

export const deleteFormVisits = (userId, submissionId) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/draftSubmissions/${submissionId}`,
      types: [DELETE_FORM_VISITS_REQUEST, DELETE_FORM_VISITS_SUCCESS, DELETE_FORM_VISITS_FAILURE],
    },
  })
}

export const POST_USERS_AGENT_REQUEST = 'POST_USERS_AGENT_REQUEST'
export const POST_USERS_AGENT_SUCCESS = 'POST_USERS_AGENT_SUCCESS'
export const POST_USERS_AGENT_FAILURE = 'POST_USERS_AGENT_FAILURE'

export const getUserAgent = uas => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/useragent`,
      types: [POST_USERS_AGENT_REQUEST, POST_USERS_AGENT_SUCCESS, POST_USERS_AGENT_FAILURE],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({ uas }),
    },
  })
}

export const GET_USER_BOUNCE_INFO_REQUEST = 'GET_USER_BOUNCE_INFO_REQUEST'
export const GET_USER_BOUNCE_INFO_SUCCESS = 'GET_USER_BOUNCE_INFO_SUCCESS'
export const GET_USER_BOUNCE_INFO_FAILURE = 'GET_USER_BOUNCE_INFO_FAILURE'

export const getUserBounceInfo = userId => dispatch =>
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/email/bounces`,
      types: [
        GET_USER_BOUNCE_INFO_REQUEST,
        GET_USER_BOUNCE_INFO_SUCCESS,
        GET_USER_BOUNCE_INFO_FAILURE,
      ],
    },
  })

export const GET_USER_COMPLAINT_INFO_REQUEST = 'GET_USER_COMPLAINT_INFO_REQUEST'
export const GET_USER_COMPLAINT_INFO_SUCCESS = 'GET_USER_COMPLAINT_INFO_SUCCESS'
export const GET_USER_COMPLAINT_INFO_FAILURE = 'GET_USER_COMPLAINT_INFO_FAILURE'

export const getUserComplaintInfo = userId => dispatch =>
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/email/complaints`,
      types: [
        GET_USER_COMPLAINT_INFO_REQUEST,
        GET_USER_COMPLAINT_INFO_SUCCESS,
        GET_USER_COMPLAINT_INFO_FAILURE,
      ],
    },
  })

export const REMOVE_USER_BOUNCE_REQUEST = 'REMOVE_USER_BOUNCE_REQUEST'
export const REMOVE_USER_BOUNCE_SUCCESS = 'REMOVE_USER_BOUNCE_SUCCESS'
export const REMOVE_USER_BOUNCE_FAILURE = 'REMOVE_USER_BOUNCE_FAILURE'

export const removeUserBounce = userId => dispatch =>
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/email/bounces`,
      types: [REMOVE_USER_BOUNCE_REQUEST, REMOVE_USER_BOUNCE_SUCCESS, REMOVE_USER_BOUNCE_FAILURE],
    },
  })

export const REMOVE_USER_COMPLAINT_REQUEST = 'REMOVE_USER_COMPLAINT_REQUEST'
export const REMOVE_USER_COMPLAINT_SUCCESS = 'REMOVE_USER_COMPLAINT_SUCCESS'
export const REMOVE_USER_COMPLAINT_FAILURE = 'REMOVE_USER_COMPLAINT_FAILURE'

export const removeUserComplaint = userId => dispatch =>
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/email/complaints`,
      types: [
        REMOVE_USER_COMPLAINT_REQUEST,
        REMOVE_USER_COMPLAINT_SUCCESS,
        REMOVE_USER_COMPLAINT_FAILURE,
      ],
    },
  })

export const RESUBSCRIBE_USER_REQUEST = 'RESUBSCRIBE_USER_REQUEST'
export const RESUBSCRIBE_USER_SUCCESS = 'RESUBSCRIBE_USER_SUCCESS'
export const RESUBSCRIBE_USER_FAILURE = 'RESUBSCRIBE_USER_FAILURE'

export const resubscribeUser = userId => dispatch =>
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PUT',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/resubscribe`,
      types: [RESUBSCRIBE_USER_REQUEST, RESUBSCRIBE_USER_SUCCESS, RESUBSCRIBE_USER_FAILURE],
    },
  })

export const GET_RECENT_LOGINS_REQUEST = 'GET_RECENT_LOGINS_REQUEST'
export const GET_RECENT_LOGINS_SUCCESS = 'GET_RECENT_LOGINS_SUCCESS'
export const GET_RECENT_LOGINS_FAILURE = 'GET_RECENT_LOGINS_FAILURE'
export const getRecentLogins =
  (userId, page = 1, pageSize = 10) =>
  dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/users/${userId}/recentLogins?page=${page}&pageSize=${pageSize}`,
        types: [GET_RECENT_LOGINS_REQUEST, GET_RECENT_LOGINS_SUCCESS, GET_RECENT_LOGINS_FAILURE],
      },
    })
  }

export const GET_IMPERSONATE_AND_GO_REQUEST = 'GET_IMPERSONATE_AND_GO_REQUEST'
export const GET_IMPERSONATE_AND_GO_SUCCESS = 'GET_IMPERSONATE_AND_GO_SUCCESS'
export const GET_IMPERSONATE_AND_GO_FAILURE = 'GET_IMPERSONATE_AND_GO_FAILURE'
export const RESET_IMPERSONATE_ERROR = 'RESET_IMPERSONATE_ERROR'
export const impersonateAndGo =
  (userId, actionId, queryParams = {}) =>
  dispatch => {
    const baseEndPoint = `${INTERNAL_API_ROOT}/admin/users/${userId}/impersonate/${actionId}`
    const qParams = new URLSearchParams(queryParams).toString()
    const endpoint = qParams ? `${baseEndPoint}?${qParams}` : baseEndPoint
    return dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint,
        types: [
          GET_IMPERSONATE_AND_GO_REQUEST,
          GET_IMPERSONATE_AND_GO_SUCCESS,
          GET_IMPERSONATE_AND_GO_FAILURE,
        ],
      },
    })
  }

export const GET_SUBMISSION_DETAILS_REQUEST = 'GET_SUBMISSION_DETAILS_REQUEST'
export const GET_SUBMISSION_DETAILS_SUCCESS = 'GET_SUBMISSION_DETAILS_SUCCESS'
export const GET_SUBMISSION_DETAILS_FAILURE = 'GET_SUBMISSION_DETAILS_FAILURE'

export const getSelectSubmissionDetails = submissionGuid => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionGuid}`,
      types: [
        GET_SUBMISSION_DETAILS_REQUEST,
        GET_SUBMISSION_DETAILS_SUCCESS,
        GET_SUBMISSION_DETAILS_FAILURE,
      ],
    },
  })
}

export const GET_SUBMISSION_HISTORY_REQUEST = 'GET_SUBMISSION_HISTORY_REQUEST'
export const GET_SUBMISSION_HISTORY_SUCCESS = 'GET_SUBMISSION_HISTORY_SUCCESS'
export const GET_SUBMISSION_HISTORY_FAILURE = 'GET_SUBMISSION_HISTORY_FAILURE'

export const getSelectSubmissionHistory = submissionGuid => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionGuid}/history`,
      types: [
        GET_SUBMISSION_HISTORY_REQUEST,
        GET_SUBMISSION_HISTORY_SUCCESS,
        GET_SUBMISSION_HISTORY_FAILURE,
      ],
    },
  })
}

export const GET_SUBMISSION_ENTRIES_REQUEST = 'GET_SUBMISSION_ENTRIES_REQUEST'
export const GET_SUBMISSION_ENTRIES_SUCCESS = 'GET_SUBMISSION_ENTRIES_SUCCESS'
export const GET_SUBMISSION_ENTRIES_FAILURE = 'GET_SUBMISSION_ENTRIES_FAILURE'

export const getSelectSubmissionEntries = submissionGuid => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionGuid}/entries`,
      types: [
        GET_SUBMISSION_ENTRIES_REQUEST,
        GET_SUBMISSION_ENTRIES_SUCCESS,
        GET_SUBMISSION_ENTRIES_FAILURE,
      ],
    },
  })
}

export const CLEAR_SUBMISSION_ENTRIES = 'CLEAR_SUBMISSION_ENTRIES'

export const clearSubmissionEntries = () => ({
  type: CLEAR_SUBMISSION_ENTRIES,
})

export const RESCIND_ADDITIONAL_ENTRIES_REQUEST = 'RESCIND_ADDITIONAL_ENTRIES_REQUEST'
export const RESCIND_ADDITIONAL_ENTRIES_SUCCESS = 'RESCIND_ADDITIONAL_ENTRIES_SUCCESS'
export const RESCIND_ADDITIONAL_ENTRIES_FAILURE = 'RESCIND_ADDITIONAL_ENTRIES_FAILURE'

export const rescindAdditionalFormEntries = (submissionGuid, entryIds) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionGuid}/entries/additional/rescind`,
      body: JSON.stringify({ entryIds }),
      types: [
        RESCIND_ADDITIONAL_ENTRIES_REQUEST,
        RESCIND_ADDITIONAL_ENTRIES_SUCCESS,
        RESCIND_ADDITIONAL_ENTRIES_FAILURE,
      ],
    },
  })
}

export const RESTORE_ADDITIONAL_ENTRIES_REQUEST = 'RESTORE_ADDITIONAL_ENTRIES_REQUEST'
export const RESTORE_ADDITIONAL_ENTRIES_SUCCESS = 'RESTORE_ADDITIONAL_ENTRIES_SUCCESS'
export const RESTORE_ADDITIONAL_ENTRIES_FAILURE = 'RESTORE_ADDITIONAL_ENTRIES_FAILURE'

export const restoreAdditionalFormEntries = (submissionGuid, entryIds) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionGuid}/entries/additional/restore`,
      body: JSON.stringify({ entryIds }),
      types: [
        RESTORE_ADDITIONAL_ENTRIES_REQUEST,
        RESTORE_ADDITIONAL_ENTRIES_SUCCESS,
        RESTORE_ADDITIONAL_ENTRIES_FAILURE,
      ],
    },
  })
}

export const REMOVE_SUBMISSION_HISTORY_ITEM = 'REMOVE_SUBMISSION_HISTORY_ITEM'

export const removeSubmissionHistoryItem = historyId => ({
  type: REMOVE_SUBMISSION_HISTORY_ITEM,
  payload: { historyId },
})

export const DELETE_SUBMISSION_HISTORY_REQUEST = 'DELETE_SUBMISSION_HISTORY_REQUEST'
export const DELETE_SUBMISSION_HISTORY_SUCCESS = 'DELETE_SUBMISSION_HISTORY_SUCCESS'
export const DELETE_SUBMISSION_HISTORY_FAILURE = 'DELETE_SUBMISSION_HISTORY_FAILURE'

export const deleteSubmissionHistory = historyId => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/history/${historyId}`,
      types: [
        DELETE_SUBMISSION_HISTORY_REQUEST,
        DELETE_SUBMISSION_HISTORY_SUCCESS,
        DELETE_SUBMISSION_HISTORY_FAILURE,
      ],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error deleting submission History`,
          dismissInSeconds: 5,
        })
      )
    } else {
      dispatch(removeSubmissionHistoryItem(historyId))
      dispatch(
        infoNotification({
          body: `Submission History item deleted`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const UPDATE_SUBMISSION_DETAIL = 'UPDATE_SUBMISSION_DETAIL'

export const updateeSubmissionDetailItem = (submissionId, target) => ({
  type: UPDATE_SUBMISSION_DETAIL,
  payload: {
    submissionId,
    fieldToUpdate: target === 'submitter' ? 'isArchivedBySubmitter' : 'isDeleted',
  },
})

export const UNDO_DELETE_SUBMISSION_REQUEST = 'UNDO_DELETE_SUBMISSION_REQUEST'
export const UNDO_DELETE_SUBMISSION_SUCCESS = 'UNDO_DELETE_SUBMISSION_SUCCESS'
export const UNDO_DELETE_SUBMISSION_FAILURE = 'UNDO_DELETE_SUBMISSION_FAILURE'

export const undoDeleteSubmission = (submissionId, target) => dispatch => {
  const isOrganization = target.includes('organization')
  const payload = isOrganization ? { isDeleted: false } : { isArchivedSubmitter: false }
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PATCH',
      endpoint: `${INTERNAL_API_ROOT}/admin/Submissions/${submissionId}`,
      types: [
        UNDO_DELETE_SUBMISSION_REQUEST,
        UNDO_DELETE_SUBMISSION_SUCCESS,
        UNDO_DELETE_SUBMISSION_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Failed to undo delete for ${target}`,
          dismissInSeconds: 5,
        })
      )
    } else {
      dispatch(updateeSubmissionDetailItem(submissionId, target))
      dispatch(
        infoNotification({
          body: `${target === 'submitter' ? 'Unarchived' : 'Undeleted'} successfully`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

// SELECTORS
export const selectUserDetails = state => state.submittable.userDetails
export const selectUser = state => selectUserDetails(state).user
export const selectUserFullName = state => selectUser(state).userDetail.fullName
export const selectUserSubmissions = state => selectUserDetails(state).userSubmissions
export const selectUserPublishers = state => selectUserDetails(state).userPublishers
export const selectUserPayments = state => selectUserDetails(state).payments
export const selectUserAccess = state => selectUserDetails(state).userAccess
export const selectFormVisits = state => selectUserDetails(state).formVisits
export const selectRecentLogins = state => selectUserDetails(state).recentLogins
export const selectImpersonateAndGo = state => selectUserDetails(state).impersonate
export const selectSubmissionDetail = state => selectUserDetails(state).submissionDetail
export const selectSubmissionHistory = state => {
  const history = selectUserDetails(state)?.submissionHistory
  return Array.isArray(history) ? [...history] : []
}

const FORM_TYPE_LABELS = {
  initial: 'Initial Form',
  eligibility: 'Eligibility Form',
  additional: 'Additional Form',
  request: 'Request Form',
  reference: 'Reference Form',
  internal: 'Internal Form',
}

const FORM_TYPE_ORDER = ['eligibility', 'initial', 'additional', 'reference', 'request', 'internal']

const REVIEW_FORM_TYPE_KEY = 'review'

const getFormTypeSortOrder = formType => {
  const normalizedType = String(formType).toLowerCase()
  const indexInOrder = FORM_TYPE_ORDER.indexOf(normalizedType)
  return indexInOrder === -1 ? FORM_TYPE_ORDER.length : indexInOrder
}

export const selectSubmissionEntries = state => {
  const rawData = selectUserDetails(state)?.submissionEntries
  const entries = Array.isArray(rawData) ? rawData : []
  const sorted = [...entries].sort((a, b) => {
    const orderA = getFormTypeSortOrder(a?.formType)
    const orderB = getFormTypeSortOrder(b?.formType)
    return orderA - orderB
  })
  return sorted.map(({ formType, entry }) => {
    const isDeleted = entry?.isDeleted === true
    const rawStatus = entry?.status ?? 'N/A'
    const status =
      isDeleted && String(rawStatus).toLowerCase() !== 'rescinded' ? 'deleted' : rawStatus
    return {
      id: entry?.entryId,
      name: entry?.formName ?? 'N/A',
      formTypeKey: String(formType).toLowerCase(),
      type: FORM_TYPE_LABELS[String(formType).toLowerCase()] ?? formType ?? 'N/A',
      createdAt: entry?.createdAt ?? null,
      submittedAt: entry?.completedAt ?? null,
      isOpenForEditing: entry?.isOpenForEditing === true,
      status,
      createdBy: entry?.createdBy ?? null,
      isDeleted,
    }
  })
}

export const selectSubmissionEntriesLoading = state =>
  selectUserDetails(state)?.submissionEntriesLoading === true

export const selectUserOrganizations = state => selectUserDetails(state).userOrganizations
export const selectEmailSuppressions = state => selectUserDetails(state).emailSuppressions
// STATE
const INITIAL_STATE = {
  user: {
    userDetail: {},
    isLoading: false,
    error: false,
  },
  userSubmissions: {
    ...pagedResponse,
  },
  payments: {
    ...pagedResponse,
  },
  userPublishers: {
    ...pagedResponse,
  },
  userAccess: {
    isLoading: false,
    accessState: {},
    error: false,
  },
  formVisits: {
    isLoading: false,
    error: false,
    items: null,
  },
  recentLogins: {
    data: [],
    isLoading: false,
    error: false,
  },
  impersonate: {
    url: '',
    isLoading: false,
    impersonateError: false,
  },
  submissionDetail: {},
  submissionHistory: {},
  submissionEntries: null,
  submissionEntriesLoading: false,
  userOrganizations: { teams: [], isLoading: false, error: false },
  emailSuppressions: {
    bounce: null,
    bounceLoading: false,
    complaint: null,
    complaintLoading: false,
    unsubscribeDate: null,
    unsubscribeReason: null,
    unsubscribedLoading: false,
  },
}

// REDUCERS
const userDetails = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_USER_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      user: {
        userDetail: { ...newPayload.user },
        isLoading: false,
        error: false,
      },
      emailSuppressions: {
        ...currentState.emailSuppressions,
        unsubscribeDate: newPayload.user?.unsubscribeDate ?? null,
        unsubscribeReason: newPayload.user?.unsubscribeReason ?? null,
      },
    }),
    [GET_USER_REQUEST]: currentState => ({
      ...currentState,
      user: {
        error: false,
        isLoading: true,
        userDetail: {},
      },
      emailSuppressions: {
        bounce: null,
        bounceLoading: false,
        complaint: null,
        complaintLoading: false,
        unsubscribeDate: null,
        unsubscribeReason: null,
        unsubscribedLoading: false,
      },
    }),
    [GET_USER_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      user: {
        userDetail: { ...currentState.user.userDetail },
        isLoading: false,
        error: { error: true, message: `${newPayload.name} - ${newPayload.status}` },
      },
    }),
    [SET_USER_DETAIL_REQUEST]: currentState => ({
      ...currentState,
      user: {
        ...currentState.user,
        userDetail: {
          ...currentState.user.userDetail,
        },
        isLoading: true,
        error: false,
      },
    }),
    [SET_USER_DETAIL_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      user: {
        ...currentState.user,
        userDetail: {
          ...currentState.user.userDetail,
          ...newPayload,
          privateNotes: newPayload.privateNotes ?? '',
          privateNotesUpdated: newPayload.privateNotesUpdated,
        },
        isLoading: false,
        error: false,
      },
    }),
    [SET_USER_DETAIL_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      user: {
        ...currentState.user,
        userDetail: {
          ...currentState.user.userDetail,
        },
        isLoading: false,
        error: {
          error: true,
          saveError: true,
          message: `${newPayload.name} - ${newPayload.status}`,
        },
      },
    }),
    [RESET_SET_USER_DETAIL_ERROR]: currentState => ({
      ...currentState,
      user: {
        ...currentState.user,
        error: false,
      },
    }),
    [GET_USER_SUBMISSIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userSubmissions: newPayload || { items: [], totalItems: 0 },
    }),
    [GET_USER_PUBLISHERS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userPublishers: newPayload,
    }),
    [GET_USER_ORGANIZATIONS_REQUEST]: currentState => ({
      ...currentState,
      userOrganizations: { ...currentState.userOrganizations.teams, isLoading: true, error: false },
    }),
    [GET_USER_ORGANIZATIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userOrganizations: { teams: newPayload, isLoading: false, error: false },
    }),
    [GET_USER_ORGANIZATIONS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      userOrganizations: {
        ...currentState.userOrganizations.teams,
        isLoading: false,
        error: newPayload,
      },
    }),
    [GET_USER_PAYMENTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      payments: newPayload,
    }),
    [GET_USER_ACCESS_STATUS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userAccess: {
        isLoading: false,
        accessState: newPayload,
        error: false,
      },
    }),
    [GET_USER_ACCESS_STATUS_REQUEST]: currentState => ({
      ...currentState,
      userAccess: {
        ...currentState.userAccess,
        isLoading: true,
      },
    }),
    [GET_USER_ACCESS_STATUS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      userAccess: {
        ...currentState.userAccess,
        isLoading: false,
        error: { error: true, message: `${newPayload.name} - ${newPayload.status}` },
      },
    }),
    [SET_USER_ACCESS_STATUS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userAccess: {
        isLoading: false,
        accessState: newPayload,
        error: false,
      },
    }),
    [SET_USER_ACCESS_STATUS_REQUEST]: currentState => ({
      ...currentState,
      userAccess: {
        ...currentState.userAccess,
        isLoading: true,
      },
    }),
    [SET_USER_ACCESS_STATUS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      userAccess: {
        ...currentState.userAccess,
        isLoading: false,
        error: { error: true, message: `${newPayload.name} - ${newPayload.status}` },
      },
    }),
    [GET_FORM_VISITS_REQUEST]: currentState => ({
      ...currentState,
      formVisits: {
        ...currentState.formVisits,
        isLoading: true,
      },
      impersonate: {
        url: '',
        isLoading: false,
        impersonateError: false,
      },
    }),
    [GET_FORM_VISITS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      formVisits: {
        ...currentState.formVisits,
        isLoading: false,
        error: null,
        items: newPayload.items,
      },
      impersonate: {
        url: '',
        isLoading: false,
        impersonateError: false,
      },
    }),
    [GET_FORM_VISITS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      formVisits: {
        ...currentState.formVisits,
        isLoading: false,
        error: { error: true, message: `${newPayload.name} - ${newPayload.status}` },
      },
      impersonate: {
        url: '',
        isLoading: false,
        impersonateError: false,
      },
    }),
    [POST_USERS_AGENT_REQUEST]: currentState => ({
      ...currentState,
      userAgent: {
        ...currentState.userAgent,
        isLoading: true,
      },
    }),
    [POST_USERS_AGENT_SUCCESS]: currentState => ({
      ...currentState,
      userAgent: {
        ...currentState.userAgent,
        isLoading: false,
        error: null,
      },
    }),
    [POST_USERS_AGENT_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      userAgent: {
        ...currentState.userAgent,
        isLoading: false,
        error: { error: true, message: `${newPayload.name} - ${newPayload.status}` },
      },
    }),
    [GET_IMPERSONATE_AND_GO_REQUEST]: currentState => ({
      ...currentState,
      impersonate: {
        url: '',
        impersonateError: false,
        isLoading: true,
      },
    }),
    [GET_IMPERSONATE_AND_GO_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      impersonate: {
        isLoading: false,
        impersonateError: false,
        url: newPayload,
      },
    }),
    [GET_IMPERSONATE_AND_GO_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      impersonate: {
        isLoading: false,
        impersonateError: {
          error: true,
          message: `${newPayload.name} - ${newPayload.status}`,
          details: newPayload,
        },
        url: '',
      },
    }),
    [RESET_IMPERSONATE_ERROR]: currentState => ({
      ...currentState,
      impersonate: {
        error: false,
        url: '',
        isLoading: false,
      },
    }),
    [GET_RECENT_LOGINS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      recentLogins: {
        data: newPayload.userRecentLogin,
        loading: false,
        error: false,
      },
    }),
    [GET_RECENT_LOGINS_REQUEST]: currentState => ({
      ...currentState,
      recentLogins: {
        ...currentState.recentLogins,
        loading: true,
        error: false,
      },
    }),
    [GET_RECENT_LOGINS_FAILURE]: currentState => ({
      ...currentState,
      recentLogins: {
        ...currentState.recentLogins,
        loading: false,
        error: true,
      },
    }),
    [GET_SUBMISSION_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      submissionDetail: newPayload,
    }),
    [GET_SUBMISSION_HISTORY_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      submissionHistory: newPayload,
    }),
    [GET_SUBMISSION_ENTRIES_REQUEST]: currentState => ({
      ...currentState,
      submissionEntriesLoading: true,
      submissionEntries: currentState.submissionEntries,
    }),
    [GET_SUBMISSION_ENTRIES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      submissionEntries: (newPayload?.formEntries ?? []).filter(
        item => String(item?.formType).toLowerCase() !== REVIEW_FORM_TYPE_KEY
      ),
      submissionEntriesLoading: false,
    }),
    [GET_SUBMISSION_ENTRIES_FAILURE]: currentState => ({
      ...currentState,
      submissionEntriesLoading: false,
      submissionEntries: [],
    }),
    [CLEAR_SUBMISSION_ENTRIES]: currentState => ({
      ...currentState,
      submissionEntries: null,
      submissionEntriesLoading: false,
    }),
    [REMOVE_SUBMISSION_HISTORY_ITEM]: (currentState, action) => {
      const { historyId } = action
      return {
        ...currentState,
        submissionHistory: currentState.submissionHistory.filter(
          item => item.historyId !== historyId
        ),
      }
    },
    [UPDATE_SUBMISSION_DETAIL]: (currentState, action) => {
      const { fieldToUpdate } = action
      return {
        ...state,
        submissionDetail: {
          ...state.submissionDetail,
          [fieldToUpdate]: false,
        },
      }
    },
    [GET_USER_BOUNCE_INFO_REQUEST]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, bounceLoading: true },
    }),
    [GET_USER_BOUNCE_INFO_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      emailSuppressions: {
        ...currentState.emailSuppressions,
        bounce: newPayload ?? false,
        bounceLoading: false,
      },
    }),
    [GET_USER_BOUNCE_INFO_FAILURE]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, bounce: null, bounceLoading: false },
    }),
    [GET_USER_COMPLAINT_INFO_REQUEST]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, complaintLoading: true },
    }),
    [GET_USER_COMPLAINT_INFO_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      emailSuppressions: {
        ...currentState.emailSuppressions,
        complaint: newPayload ?? false,
        complaintLoading: false,
      },
    }),
    [GET_USER_COMPLAINT_INFO_FAILURE]: currentState => ({
      ...currentState,
      emailSuppressions: {
        ...currentState.emailSuppressions,
        complaint: null,
        complaintLoading: false,
      },
    }),
    [REMOVE_USER_BOUNCE_REQUEST]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, bounceLoading: true },
    }),
    [REMOVE_USER_BOUNCE_SUCCESS]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, bounce: false, bounceLoading: false },
    }),
    [REMOVE_USER_BOUNCE_FAILURE]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, bounceLoading: false },
    }),
    [REMOVE_USER_COMPLAINT_REQUEST]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, complaintLoading: true },
    }),
    [REMOVE_USER_COMPLAINT_SUCCESS]: currentState => ({
      ...currentState,
      emailSuppressions: {
        ...currentState.emailSuppressions,
        complaint: false,
        complaintLoading: false,
      },
    }),
    [REMOVE_USER_COMPLAINT_FAILURE]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, complaintLoading: false },
    }),
    [RESUBSCRIBE_USER_REQUEST]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, unsubscribedLoading: true },
    }),
    [RESUBSCRIBE_USER_SUCCESS]: currentState => ({
      ...currentState,
      emailSuppressions: {
        ...currentState.emailSuppressions,
        unsubscribeDate: null,
        unsubscribeReason: null,
        unsubscribedLoading: false,
      },
    }),
    [RESUBSCRIBE_USER_FAILURE]: currentState => ({
      ...currentState,
      emailSuppressions: { ...currentState.emailSuppressions, unsubscribedLoading: false },
    }),
  }[type]?.(state, payload) || state)

export default userDetails
